import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EntityListComponent } from 'app/components/entity-list/entity-list.component';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { DriverAssignmentsService } from 'app/modules/vehicle-inventory/services/driver-assignments.service';
import { InvVehicleService } from 'app/modules/vehicle-inventory/services/invVehicle.service';
import { RestVehicleInventory } from 'app/modules/vehicle-inventory/services/rest_vehicle-inventory';
import { DelegationService } from 'app/modules/vehicle-inventory/services/table-management/delegation.service';
import { VehicleAssignmentsService } from 'app/modules/vehicle-inventory/services/vehicle-assignments.service';
import { CecoService } from 'app/rest/ceco.service';
import { DivisionService } from 'app/rest/division.service';
import { Rest } from 'app/rest/rest_client';
import { SubdelegationService } from 'app/rest/subdelegation.service';
import { SubdivisionService } from 'app/rest/subdivision.service';
import { ExcelService } from 'app/services/excel-service/excel.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { LoadingService } from 'app/services/loading-service/loading.service';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { VehicleAssignmentsFormComponent } from '../vehicle-assignments-form/vehicle-assignments-form.component';

@Component({
    selector: 'app-vehicle-assignments-list',
    templateUrl: './vehicle-assignments-list.component.html',
    styleUrls: ['./vehicle-assignments-list.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VehicleAssignmentsListComponent extends EntityListComponent<Rest.InvVehicleAssignment> implements OnInit, OnDestroy {
	title: string = "Assignments";

	@Input() vehicle?: Rest.Vehicle = null;
	@Input() startDate?: Date = null;
	@Input() endDate?: Date = null;

	refreshListSuscription: Subscription;

	delegationList: Rest.Delegation[] = [];
	isDelegationListLoaded: Boolean = false;
	subdelegationList: Rest.Subdelegation[] = [];
	isSubdelegationListLoaded: Boolean = false;
	companiesList: Rest.BillingAccount[] = [];
	isCompaniesListLoaded: Boolean = false;
	cecoList: Rest.Ceco[] = [];
	isCecoListLoaded: Boolean = false;

	user: Rest.User;
	EnabledFilter: SelectItem[];
	canDelete: boolean;
	
	@ViewChild(VehicleAssignmentsFormComponent, { static: true })
	vehicleAssignmentsForm: VehicleAssignmentsFormComponent;
	@Output() refreshVehicleAssignment: EventEmitter<void> = new EventEmitter<void>();

	constructor(
		 protected vehicleAssignmentsService: VehicleAssignmentsService,
		 protected confirmationService: ConfirmationService,
		 public notificationsService: NotificationsService,
		 protected i18n: I18nService,
		 authenticationService: AuthenticationService,
		 protected loadingService: LoadingService,
		 protected userTime: UserTimePipe,
		 protected excelService: ExcelService,
		 protected translateService: TranslateService,
		 public delegationService: DelegationService,
		 public subdelegationService: SubdelegationService,
		 public invVehicleService: InvVehicleService,
		 public cecoService: CecoService,
	) {
		 super(
			  vehicleAssignmentsService,
			  confirmationService,
			  notificationsService,
			  i18n,
			  authenticationService,
			  loadingService,
			  userTime,
			  excelService
		 );
	}

	ngOnInit() {
		 super.ngOnInit();
		 /*Permissions */
		 this.user = this.authenticationService.user;
		 this.form = this.vehicleAssignmentsForm;
		 this.setPermissions();
		 /** */
		 this.getCecoList();
		 this.getBillingAccounts(this.user.client.id);
		 this.getDelegationList(this.vehicle.client.id);
		 this.getSubdelegationList(this.vehicle.client.id);
		 this.refreshListSuscription = this.vehicleAssignmentsService.refreshList.subscribe(
			(item: RestVehicleInventory.InvVehicleHtcRequest) => {
				// console.log("[VEHICLE-ASSIGNMENTS-LIST] refreshList ***");
				// console.log(item);
				this.getList(item.startDate, item.endDate);
			}
		);
	}

	onDestroy() {
		this.refreshListSuscription.unsubscribe();
	}

	setPermissions() {
		this.canDelete = this.authenticationService.isRoleGranted('INV_VEHICLE_ASSIGNMENTS_DELETE', this.user);
	}	

	public getList(startDate: Date, endDate: Date) {
		// console.log("[VEHICLE-ASSIGNMENTS-LIST] getList ***");
		this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];
		this.startDate = startDate;
		this.endDate = endDate;
		if (this.startDate) this.paginationRequest.filters['startDate'] = [this.startDate.toISOString()];
		if (this.endDate) this.paginationRequest.filters['endDate'] = [this.endDate.toISOString()];
		// console.log(this.paginationRequest);
		super.refresh();
	}

	beforeLoad(): void {

		if(this.paginationRequest.sortBy == null || this.paginationRequest.sortBy == ''){
			this.paginationRequest.sortBy = "endDate";
			this.paginationRequest.sortAsc= false;
		}
		if (this.vehicle) this.paginationRequest.filters['vehicleId'] = [this.vehicle.id.toString()];
		if (this.startDate) this.paginationRequest.filters['startDate'] = [this.startDate.toISOString()];
		if (this.endDate) this.paginationRequest.filters['endDate'] = [this.endDate.toISOString()];
	}

	public afterLoad() {
		// console.log("[VEHICLE-ASSIGNMENTS-LIST] afterLoad ***");
		// console.log(this.paginationResult);
	}

	public getDelegationList(clientId: number) {
		// console.log("[VEHICLE-ASSIGNMENTS-LIST] getDelegationList ***");
		// console.log(clientId);
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.delegationService
				.getList(clientId)
				.then(
			 		function (response) {
						that.delegationList = response;
						that.isDelegationListLoaded = true;
						// console.log("*** delegationList ***");
						// console.log(that.delegationList);
			 		},
			 		/* failure */
			 		function (error) {
						console.log('The request failed: ' + error);
				  		resolve();
			 		},
				)
			.catch(function (reason) {
				console.log('Catched: ' + reason);
				resolve();
			});
		});
	}

	public getSubdelegationList(clientId: number) {
		// console.log("[VEHICLE-ASSIGNMENTS-LIST] getSubdelegationList ***");
		// console.log(clientId);
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.subdelegationService
				.getListByClient(clientId)
				.then(
			 		function (response) {
						that.subdelegationList = response;
						that.isSubdelegationListLoaded = true;
						// console.log("*** subdelegationList ***");
						// console.log(that.subdelegationList);
			 		},
			 		/* failure */
			 		function (error) {
						console.log('The request failed: ' + error);
				  		resolve();
			 		},
				)
			.catch(function (reason) {
				console.log('Catched: ' + reason);
				resolve();
			});
		});
	}

	public getBillingAccounts(clientId: number) {
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.invVehicleService
				.getBillingAccounts(clientId)
				.then(
					function (response) {
						that.companiesList = response;
						if (response === null || response === undefined) {
							that.notificationsService.add(
								Severity.warn,
								that.translateService.instant('general.warn') + '!',
								that.translateService.instant('control-panel.vehicles.billingAccount') +
								': ' +
								that.translateService.instant('table.tableEmptyMessage')
							);
						}
						that.isCompaniesListLoaded = true;
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					}
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}

	getCecoList() {
		let cecoFilterRequest = {
			sortBy: null,
			sortAsc: true,
			pageSize: 2147483647,
			filters: {},
			loadPermissions: false
			//offset: event.first // número de pàgina (lazyload)
			//pageSize: event.rows // número de files (lazyload)
		} as unknown as Rest.ListPaginationRequest;
		const promise = new Promise<void>((resolve, reject) => {
			const that = this;
			this.cecoService.getPage(cecoFilterRequest)
				.then(
					function (response) {
						that.cecoList = response.entities;
						that.isCecoListLoaded = true;
					},
					/* failure */
					function (error) {
						console.log('The request failed: ' + error);
						resolve();
					},
					
				)
				.catch(function (reason) {
					console.log('Catched: ' + reason);
					resolve();
				});
		});
	}


	excelColumns = {};

	exportExcel(){
		 this.setExcelColumns();
		 let fileNameTitle = this.translateService.instant('vehicleAssignments.header');
		 super.exportExcelWithColumns(fileNameTitle,  this.excelColumns);
	}
	setExcelColumns() {
		const billingAccount = (entity: any) => `(${entity.company?.code ?? ''}) ${entity.company?.name ?? ''}`
		const startDate = (entity: any) => entity.startDate ?? '';
		const endDate = (entity: any) => entity.endDate ?? '';
		const delegation = (entity: any) => `(${entity.delegation?.code ?? ''}) ${entity.delegation?.name ?? ''}`
		const subDelegation = (entity: any) => `(${entity.subDelegation?.code ?? ''}) ${entity.subDelegation?.name ?? ''}`
		const ceco = (entity: any) => `(${entity.ceco?.code ?? ''}) ${entity.ceco?.description ?? ''}`

	   this.excelColumns = {
			[this.translateService.instant('drivers.form.company')]: {  bindField: billingAccount },
			[this.translateService.instant('tableManagement.cardLists.assignDateShort')]: { bindField: startDate },
			[this.translateService.instant('tableManagement.cardLists.deassignDateShort')]: {  bindField: endDate },
			[this.translateService.instant('tableManagement.delegations.delegation')]: {  bindField: delegation },
			[this.translateService.instant('tableManagement.subdelegations.subdelegation')]: {  bindField: subDelegation },
			[this.translateService.instant('drivers.form.ceco')]: {  bindField: ceco },

		   }
   }

	deleteAssignment(assignment: Rest.InvVehicleAssignment) {
		var that = this;
		this.vehicleAssignmentsService.deleteAssignment(assignment.id).then((response) => {
			if (response) {
				that.notificationsService.add(Severity.success, '', this.translateService.instant('general.deleteSuccessfull'));
				

				if(assignment.id == this.paginationResult.entities[0].id){
					that.refreshVehicleAssignment.emit();
				}

				that.refresh();

			} else {
				that.notificationsService.add(Severity.error, '', this.translateService.instant('general.deleteError'));
			}
		});
	}

	public onDeleteAssignment(assignment: Rest.InvVehicleAssignment) {

		this.confirmationService.confirm({
			accept: () => {
				this.deleteAssignment(assignment);
			},
			key:'vehicle-assignments-list'
		});
	}



	}
